import base from "./base.vue";
export default base;
